"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterSetBfromA = exports.setAContainsOnlySomeB = exports.setAContainsAllB = exports.setAContainsSomeB = exports.matchObjectKeysDebug = exports.objectKeysAreSameOrder = exports.matchObjectKeys = exports.matchKeysOnly = exports.diffObjects = exports.objectsMatchDebug = exports.objectsMatch = exports.objectsMatchByHash = exports.getObjectHash = void 0;
const tslib_1 = require("tslib");
const crypto_1 = tslib_1.__importDefault(require("crypto"));
const safe_stable_stringify_1 = require("safe-stable-stringify");
const Validation_1 = require("../../Validation");
tslib_1.__exportStar(require("./identity"), exports);
/**
 * Returns hash of object based on 'safe-stable-stringify' package.
 *
 * @description
 *
 * This function does something similar to JSON.stringify, but more than it.
 * It then converts it to a safe, short hash via the `crypto` module
 *
 * @example
 * ```
 * import crypto from 'crypto'
 * import hash from 'stable-hash'
 *
 * const longHash = stringify(anyJavaScriptValueHere)
 * const displayableHash = Buffer.from(longHash).toString('base64')
 * const shortHash = crypto.createHash('sha256').update(longHash).digest('hex')
 * ```
 *
 * Was previously using the `object-hash` package, but this had issues and didn't produce a stable hashs
 *
 * `seenObjects` is deprecated and unused
 */
const getObjectHash = (ob, /** @deprecated */ seenObjects = []) => {
    const stringHash = ob ? ((0, safe_stable_stringify_1.stringify)(ob) ?? '~') : '~';
    const shortHash = crypto_1.default.createHash('sha256').update(stringHash).digest('hex');
    return shortHash;
};
exports.getObjectHash = getObjectHash;
const objectsMatchByHash = (template, ob) => (0, exports.getObjectHash)(template) === (0, exports.getObjectHash)(ob);
exports.objectsMatchByHash = objectsMatchByHash;
const oMatchDebug = false;
/**
 * @underReview the logic here is likely to be replaced by objectsMatchByHash when proven
 * @function objectsMatch tests whether the attributes in ob that match the attributes of template have the same value
 * @warning this may produce unexpected results where ob has been rehydated and undefined attributes has been omitted,
 * @warning this will match elements in arrays based on the number of items in an array nested in template, but is incorrect currently if the same array in ob has same first items but then additional items
 * @param template
 * @param ob
 * @returns
 */
const objectsMatch = (template, ob) => {
    if (!template || !ob) {
        console.log(`WARN: unhandled presentation of undefined params to objectsMatch`, { template, ob });
        return false;
    }
    if (template === ob) {
        return true;
    }
    return Object.entries(template).reduce((acc, [k, v]) => {
        if (typeof v !== 'function') {
            oMatchDebug && console.log(`matching ${k} on ${JSON.stringify(ob[k])} with ${JSON.stringify(v)}`);
            return acc && ((ob[k] === undefined && v === undefined) || (ob[k] !== undefined && (typeof v === 'object' ? (0, exports.objectsMatch)(v, ob[k]) : v === ob[k])));
        }
        else {
            return acc;
        }
    }, true);
};
exports.objectsMatch = objectsMatch;
const objectsMatchDebug = (template, ob) => {
    return Object.entries(template).reduce((acc, [k, v]) => {
        if (ob[k] !== undefined) {
            if (typeof v === 'object') {
                acc[k] = (0, exports.objectsMatchDebug)(v, ob[k]);
            }
            else {
                if (v !== ob[k]) {
                    acc[k] = ob[k];
                }
            }
        }
        return acc;
    }, {});
};
exports.objectsMatchDebug = objectsMatchDebug;
const diffObjects = (template, ob) => {
    if (template === ob) {
        return {};
    }
    return Object.entries(template).reduce((acc, [k, v]) => {
        if (typeof v !== 'function') {
            if (v !== undefined && ob[k] === undefined) {
                acc[k] = `${k} non existant`;
            }
            else if (v !== null && ob[k] === null) {
                acc[k] = `${k} null object`;
            }
            else if (typeof v === 'object' && v !== null) {
                acc[k] = (0, exports.diffObjects)(v, ob[k]);
            }
            else if (v instanceof Array) {
                acc[k] = (0, exports.diffObjects)(v, ob[k]);
            }
            else if (v !== ob[k]) {
                acc[k] = `${v} : ${ob[k]}`;
            }
            else {
            }
        }
        return acc;
    }, {});
};
exports.diffObjects = diffObjects;
/** Returns true if the ob has at least all the ( nested keys ) of the template */
const matchKeysOnly = (template, ob) => {
    if (!(0, Validation_1.isNullish)(template)) {
        return Object.entries(template).reduce((acc, [k, v]) => {
            const obIsNullish = (0, Validation_1.isNullish)(ob);
            if (obIsNullish) {
                // template val is not nullish but ob is
                return false;
            }
            else {
                // both not nullish
                return acc && Object.keys(ob).includes(k) && (typeof v === 'object' ? (0, exports.matchKeysOnly)(v, ob[k]) : true);
            }
        }, true);
    }
    else {
        // both null or ob is not an object
        return typeof ob !== 'object' || (0, Validation_1.isNullish)(ob);
    }
};
exports.matchKeysOnly = matchKeysOnly;
/** Matches keys AND values, initally desgined for templates where fields are undefined'd out. This is somewhat misleadingly named, use matchKeysOnly to test for keys but not values */
const matchObjectKeys = (template, ob) => {
    return Object.entries(template).reduce((acc, [k, v]) => {
        return acc && Object.keys(ob).includes(k) && (typeof v === 'object' ? (0, exports.matchObjectKeys)(v, ob[k]) : v === undefined || v === ob[k]);
    }, true);
};
exports.matchObjectKeys = matchObjectKeys;
const objectKeysAreSameOrder = (a, b) => Object.keys(a).every((k, i) => Object.keys(b)[i] === k);
exports.objectKeysAreSameOrder = objectKeysAreSameOrder;
const matchObjectKeysDebug = (template, ob) => {
    return Object.entries(template).reduce((acc, [k, v]) => {
        const includesK = Object.keys(ob).includes(k);
        if (!(typeof v === 'object')) {
        }
        else {
            const unmatchedKeys = (0, exports.filterSetBfromA)(Object.keys(v), Object.keys(ob[k] ?? {}));
            if (unmatchedKeys.length > 0)
                console.log(`${k} is an object with unmatched keys ${unmatchedKeys.join(', ')}`);
        }
        const res = acc && includesK && (typeof v === 'object' ? (0, exports.matchObjectKeysDebug)(v, ob[k]) : v === undefined || v === ob[k]);
        return res;
    }, true);
};
exports.matchObjectKeysDebug = matchObjectKeysDebug;
const isMapLike = (x) => x && typeof x === 'object'; // purely to make objectsMatch work with setContains
/** this was flawed and improved but doesnt deal with arrays */
const setAContainsSomeB = (A, B) => B.some((b) => A.find((a) => (isMapLike(a) && isMapLike(b) ? (0, exports.objectsMatch)(a, b) : a === b)));
exports.setAContainsSomeB = setAContainsSomeB;
const setAContainsAllB = (A, B) => B.every((b) => A.find((a) => (isMapLike(a) && isMapLike(b) ? (0, exports.objectsMatch)(a, b) : a === b)));
exports.setAContainsAllB = setAContainsAllB;
const setAContainsOnlySomeB = (A, B) => A.every((a) => B.find((b) => (isMapLike(a) && isMapLike(b) ? (0, exports.objectsMatch)(a, b) : a === b)));
exports.setAContainsOnlySomeB = setAContainsOnlySomeB;
const filterSetBfromA = (A, B) => A.filter((a) => !B.find((b) => (isMapLike(a) && isMapLike(b) ? (0, exports.objectsMatch)(a, b) : a === b)));
exports.filterSetBfromA = filterSetBfromA;
